import React, { useState } from 'react';

import CallModal from 'views/CallModal.js';
import { EVENTS, logBookingEvent } from 'files/Analytics.js';
import Utils from 'files/Utils.js';

const FIRE = '#D63D1F';

const Header = () => {

    const isMobile = Utils.isMobile();
    const phoneNumber = Utils.getPhoneNumber();

    const [callModalVisible, setCallModalVisible] = useState(false);

    const onPhoneClick = () => {
        // attempt the dialer, falling back to the call-info modal when no tel:
        // handler is available (see Utils.attemptPhoneCall)
        logBookingEvent(EVENTS.PHONE_NUMBER_CLICK, { phone_number: phoneNumber });
        Utils.attemptPhoneCall(phoneNumber, () => setCallModalVisible(true));
    }

    return (
        <React.Fragment>
        <header style={{
            backgroundColor: '#FFFFFF',
            borderBottom: '1px solid rgba(220,220,220,0.4)',
            left: 0,
            position: 'fixed',
            right: 0,
            top: 0,
            width: '100%',
            zIndex: 50
        }}>
            <div style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                margin: '0 auto',
                maxWidth: 1280,
                padding: isMobile ? '16px 16px' : '16px 32px 16px 16px',
                width: '100%'
            }}>
                <img
                alt={'OmniShield Logo'}
                src={require('assets/omnishield-logo.webp')}
                style={{
                    height: isMobile ? 40 : 48,
                    objectFit: 'contain'
                }} />
                <nav 
                className="items-center gap-4 md:gap-8" 
                style={{
                    display: isMobile ? 'none' : 'flex'
                }}>
                <button
                onClick={onPhoneClick}
                style={{
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    border: 'none',
                    borderRadius: 8,
                    color: FIRE,
                    cursor: 'pointer',
                    display: 'inline-flex',
                    fontFamily: '"Lato", sans-serif',
                    fontSize: 24,
                    fontWeight: 700,
                    gap: 8,
                    margin: '8px 0',
                    transition: 'transform 0.3s'
                }}>
                    <i className={'fas fa-phone'} style={{ fontSize: 20 }} />
                    <span>{phoneNumber}</span>
                </button>
                </nav>
            </div>
        </header>
        {callModalVisible && (
            <CallModal
            phoneNumber={phoneNumber}
            onClose={() => setCallModalVisible(false)} />
        )}
        </React.Fragment>
    )
}

export default Header;
